<script setup lang="ts">
import type { Icons } from './base/BaseIcon.vue'

const props = defineProps<{
  module: 'e-reputation' | 'pongo-suite'
  noBorderGradient?: boolean
}>()

const iconName = computed<Icons>(() => (props.module === 'e-reputation' ? 'IconoirMagnet' : 'IconoirInfinite'))
</script>

<template>
  <div class="custom-purple-shadow flex bg-primary/70 rounded-3xl p-[1px] relative">
    <div
      class="flex flex-col text-center rounded-3xl p-2 relative"
      :class="noBorderGradient ? 'bg-brand' : 'bg-brand-gradient-b'"
    >
      <div class="bg-white/30 rounded-2xl p-[1px] custom-shadow">
        <div class="flex flex-col text-center bg-brand-gradient-b rounded-2xl p-3">
          <BaseIcon :name="iconName" class="size-8 text-white" />
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.custom-shadow {
  box-shadow:
    0 4px 4px 0 rgba(0, 0, 0, 0.25),
    0 2.5px 15px 0 rgba(6, 6, 6, 0.15);
}

.custom-purple-shadow {
  box-shadow: 0 8px 24px 0 rgba(124, 58, 237, 0.25);
}
</style>
